import React from "react";

import BaseComponent from "../../../../redare/components/BaseComponent";
import { Row, Col, Switch } from "antd";
import ApplicationPresenter from "../../../../../src/.gen/presenter/ApplicationPresenter";

export default class RoleApp extends BaseComponent {

    static defaultProps = {
        platform: undefined,
        onRoleSelected: undefined
    };

    constructor(props) {
        super(props);
        this.state = {
            applicationList: [],
            arr: [],
        }
        this.applicationPresenter = new ApplicationPresenter(this);
    }

    componentDidMount() {
        this.applicationPresenter.findApplicationOfUserList(
            { classify: "application", isShowPC: 1 },
            {},
            (result) => {
                this.setState({ applicationList: result.data });
            });
    }

    setRoleId(role) {
        this.setState({
            role
        });
        if (role) {
            this.applicationPresenter.applicationList({}, { roleId: role.roleId }, res => {
                if (res.code == 0) {
                    this.setState({ arr: res.data });
                }
            });
        }
    }

    add(item) {
        if (this.state.role) {
            let values = {
                roleId: this.state.role.roleId,
                roleName: this.state.role.name,
                applicationId: item.id,
                applicationCode: item.sysCode,
            }
            this.applicationPresenter.addApplicationList(values, {}, res => {
                if (res.code == 0) {
                    this.setRoleId(this.state.role)
                }
            });
        }
    }

    del(id) {
        if (this.state.role) {
            let values = {
                id
            }
            this.applicationPresenter.delApplicationList({}, values, res => {
                if (res.code == 0) {
                    this.setRoleId(this.state.role)
                }
            });
        }
    }

    render() {
        let applicationList = this.state.applicationList;
        return <>
            <Row>
                {
                    applicationList.map(item => {
                        let state = this.state.arr.find(v => {
                            return v.applicationId == item.id
                        })
                        return (
                            <Col span={6} key={item.id} style={{ textAlign: "center", marginBottom: 30 }}>
                                <img className="img"
                                    style={{ width: 50 }}
                                    src={item.icon === undefined ? "" : item.icon} />
                                <p>{item.name}</p>
                                <Switch
                                    checked={state ? true : false}
                                    style={{ marginTop: -30 }}
                                    onChange={v => {
                                        if (v) {
                                            this.add(item);
                                        } else {
                                            this.del(state.id);
                                        }
                                    }}
                                />
                            </Col>
                        );
                    })
                }
            </Row>
        </>
    }
}
